export function isScanEnabled(siteSetting) {
  return (
    siteSetting.scan_and_go_enabled ||
    siteSetting.coupons_enabled ||
    siteSetting.toilet_voucher_enabled
  );
}
